import { render, staticRenderFns } from "./Building.vue?vue&type=template&id=0d37aa24&scoped=true"
import script from "./Building.vue?vue&type=script&lang=js"
export * from "./Building.vue?vue&type=script&lang=js"
import style0 from "./Building.vue?vue&type=style&index=0&id=0d37aa24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37aa24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d37aa24')) {
      api.createRecord('0d37aa24', component.options)
    } else {
      api.reload('0d37aa24', component.options)
    }
    module.hot.accept("./Building.vue?vue&type=template&id=0d37aa24&scoped=true", function () {
      api.rerender('0d37aa24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Building.vue"
export default component.exports